// Shared voucher generators - logic copied verbatim from FacebookEventsPage.js
// (handleGenerateVoucher / handleGenerateVoucher2) so ClientProfile produces
// byte-identical vouchers. FacebookEventsPage still uses its own inline copies.

const parseEndDate = (endDateValue) => {
  if (endDateValue?.seconds) {
    return new Date(endDateValue.seconds * 1000);
  } else if (typeof endDateValue === 'string') {
    return new Date(`${endDateValue}T00:00:00`);
  }
  return new Date(endDateValue);
};

const getTodayStamp = () => {
  const today = new Date();
  return `${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getDate().toString().padStart(2, '0')}${today.getFullYear()}`;
};

const triggerDownload = (canvas, filename) => {
  const dataUrl = canvas.toDataURL('image/png');
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  a.click();
};

// Regular event voucher (client.voucherTemplate, falls back to /voucher.jpg)
export const generateEventVoucher = async (event, client) => {
  try {
    let cleanDate = 'Invalid Date';
    let year = '';

    const rawDate = parseEndDate(event.endDate);

    if (!isNaN(rawDate.getTime())) {
      const day = rawDate.getDate();
      year = rawDate.getFullYear();
      const month = rawDate.toLocaleString('en-US', { month: 'long' });

      const getOrdinal = (n) => {
        if (n > 3 && n < 21) return 'th';
        switch (n % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };

      cleanDate = `${month} ${day}${getOrdinal(day)}, ${year}`;
    }

    const cleanedName = (client?.name || '')
      .replace(/\n|\r/g, '')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const scale = 2;
    const canvas = document.createElement('canvas');
    canvas.width = 612 * scale;
    canvas.height = 792 * scale;
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);

    const formattedDate = getTodayStamp();

    const background = new Image();
    background.crossOrigin = 'anonymous';

    background.onload = () => {
      ctx.drawImage(background, 0, 0, 612, 792);

      const numericDate = `${(rawDate.getMonth() + 1).toString().padStart(2, '0')}/${rawDate.getDate().toString().padStart(2, '0')}/${year}`;
      ctx.fillStyle = 'black';
      ctx.textAlign = 'right';
      ctx.font = 'bold 18px Arial';
      ctx.fillText(`EXPIRES: ${numericDate}`, 600, 280);

      ctx.fillStyle = 'black';
      ctx.font = 'bold 22px "Capellina Caps", serif';
      ctx.textAlign = 'center';
      ctx.fillText(`Expires: ${cleanDate}`, 306, 141);

      if (client?.blackLogo) {
        const logo = new Image();
        logo.crossOrigin = 'anonymous';
        logo.onload = () => triggerDownload(canvas, `${cleanedName}_${formattedDate}.png`);
        logo.onerror = () => triggerDownload(canvas, `${cleanedName}_${formattedDate}.png`);
        logo.src = client.blackLogo;
      } else {
        triggerDownload(canvas, `${event.jobName || 'voucher'}_${formattedDate}.png`);
      }
    };

    background.onerror = () => {
      alert('Notify Admin this client has no voucher');
    };

    background.src = client?.voucherTemplate || `${window.location.origin}/voucher.jpg`;

  } catch (error) {
    console.error('Error generating voucher:', error);
    alert('Error generating voucher');
  }
};

// $500 Off voucher (client.voucherTemplate2, falls back to /voucher2.jpg)
export const generate500Voucher = async (event, client) => {
  if (!event.endDate) {
    alert('Event must have an end date to generate voucher');
    return;
  }

  try {
    const canvas = document.createElement('canvas');
    const scale = 2;
    canvas.width = 612 * scale;
    canvas.height = 792 * scale;
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);

    const background = new Image();
    background.crossOrigin = 'anonymous';

    background.onload = () => {
      ctx.drawImage(background, 0, 0, 612, 792);

      const rawDate = parseEndDate(event.endDate);

      const month = (rawDate.getMonth() + 1).toString().padStart(2, '0');
      const day = rawDate.getDate().toString().padStart(2, '0');
      const year = rawDate.getFullYear();
      const numericDate = `${month}/${day}/${year}`;

      const cleanedName = (event.jobName || 'voucher')
        .replace(/[^a-zA-Z0-9]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');

      const formattedDate = getTodayStamp();

      ctx.fillStyle = 'black';
      ctx.font = 'bold 18px Arial';
      ctx.textAlign = 'right';
      ctx.fillText(`EXPIRES: ${numericDate}`, 600, 315);

      if (client?.blackLogo) {
        const logo = new Image();
        logo.crossOrigin = 'anonymous';
        logo.onload = () => triggerDownload(canvas, `${cleanedName}_voucher2_${formattedDate}.png`);
        logo.onerror = () => triggerDownload(canvas, `${cleanedName}_voucher2_${formattedDate}.png`);
        logo.src = client.blackLogo;
      } else {
        triggerDownload(canvas, `${event.jobName || 'voucher'}_voucher2_${formattedDate}.png`);
      }
    };

    background.onerror = () => {
      alert('Notify Admin this client has no voucher');
    };

    background.src = client?.voucherTemplate2 || `${window.location.origin}/voucher2.jpg`;

  } catch (error) {
    console.error('Error generating voucher 2:', error);
    alert('Error generating voucher 2');
  }
};